<div class="tabs">
  <ng-container *ngFor="let tab of tabs">
    <div
      class="tabs__tab"
      [ngClass]="{'tabs__tab--selected': tab.value === activeTab, 'tabs__tab--inactive': tab.inactive}"
      (click)="setActiveTab(tab)"
    >
      <span class="tabs__tab__label">{{ tab.key }}</span>
      <ng-container *ngIf="tab.inactive">
        <div class="tabs__tab__popup mfp-white-box">
          {{ inactiveTabAdvice }}
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="showAdd">
    <mfp-add-button
      class="tabs__add-button"
      iconSize="small"
      (click)="add.emit()"
    ></mfp-add-button>
  </ng-container>
</div>
